
<div class="input-icon-start me-3 position-relative ngx-dates">
  <span class="icon-addon">
    <i class="isax isax-calendar-edit fs-14"></i>
</span>
  <input type="text" class="form-control date-range bookingrange" container=".ngx-dates" placeholder="dd/mm/yyyy - dd/mm/yyyy" bsDaterangepicker [(ngModel)]="bsRangeValue" name="time" [bsConfig]="{ adaptivePosition: true }">
</div>